<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp; Monthly Conveyance Reports</h5>
  </div>
<div id="mainContent" class="container" *ngIf="showMonthlyConveyanceDetails">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSelected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployee"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Roles<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedRole"
                #designateRole="ngModel"
              >
                <mat-option
                  (click)="selectAllRole(designateRole, roleList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option #item *ngFor="let role of roleList" [value]="role">
                  {{ role.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedBranch"
                #designateBranch="ngModel"
              >
                <mat-option
                  (click)="selectAllBranch(designateBranch, branchList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  #item
                  *ngFor="let branch of branchList"
                  [value]="branch"
                >
                  {{ branch.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <div class="col-sm-5">
            <button
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Details
            </button>
          </div>
          <div class="col-sm-5" *ngIf="showExportToExcelButton">
            <button
              (click)="exportToExcelMonthlyCoveyance()"
              class="btn btn-sm btn-block btn-outline-theme"
            >
              <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
            </button>
          </div>
        </div>
      </div>
    </div>
</div>
</div>

    <div 
      class="container pt-3 pb-2" id="mainContent"
      *ngIf="monthlyConveyanceDetailList != null && showMonthlyConveyanceDetails"
    >
    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>

      <div class="row justify-content-center text-center">
          <span class="bg-theme-title"
            >Financial Year {{ selectedFinancialYear.name }}</span
          >
      </div>
      <div *ngFor="let role of monthlyConveyanceDetailList.roles">
        <div class="row mt-2">
          <div class="col-sm-6">
            <label class="col-form-label"
              ><b>Role: {{ role.role }}</b></label
            >
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-5"></div>
              <div class="col-sm-6">
                <label class="col-form-label">
                  <b>
                    Closing Date:
                    {{
                      selectedClosing.closingDate === "Not Closed"
                        ? "Not Closed"
                        : (selectedClosing.closingDate | date: "dd-MMM-yyyy")
                    }}
                  </b>
                </label>
              </div>
            </div>
          </div>
        </div>
        <table class="table table-bordered table-sm table-striped">
          <thead>
            <tr>
              <th rowspan="2">Branch</th>
              <th rowspan="2">Employee Name</th>
              <th rowspan="2">Period</th>
              <th colspan="3" style="text-align: center">Conveyance</th>
            </tr>
            <tr>
              <th>chargeable</th>
              <th>Non chargeable</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let branch of role.branches;
                let branchIndex = index;
                let branchCount = count
              "
            >
              <ng-container
                *ngFor="
                  let details of branch.details;
                  let detailIndex = index;
                  let detailsCount = count
                "
              >
                <ng-container
                  *ngFor="
                    let period of details.periodDetails;
                    let periodIndex = index;
                    let periodCount = count
                  "
                >
                  <tr *ngIf="detailIndex == 0 && periodIndex == 0">
                    <td
                      [attr.rowspan]="
                        setRowSpanForBranchDetails(branch) + detailsCount
                      "
                    >
                      {{ branch.branch }}
                    </td>
                    <td [attr.rowspan]="periodCount + 1">
                      {{ details.firstName }} {{ details.lastName }}
                    </td>
                    <td
                      (click)="
                        getDaywiseConveyanceDetails(
                          details.firstName,
                          details.lastName,
                          details.usersId,
                          period.month,
                          period.year
                        )
                      "
                      style="cursor: pointer;text-decoration: underline;color: #800000!important;"
                    > {{ changeMonthNumberToName(period.month) }}-{{
                        period.year
                      }}
                    </td>
                    <td>{{ period.chargeble }}</td>
                    <td>{{ period.nonChargeble }}</td>
                    <td>{{ period.chargeble + period.nonChargeble }}</td>
                  </tr>
                  <tr *ngIf="detailIndex != 0 && periodIndex == 0">
                    <td [attr.rowspan]="periodCount + 1">
                      {{ details.firstName }} {{ details.lastName }}
                    </td>
                    <td
                      (click)="
                        getDaywiseConveyanceDetails(
                          details.firstName,
                          details.lastName,
                          details.usersId,
                          period.month,
                          period.year
                        )
                      "
                      style="cursor: pointer; color: #800000!important"
                    >
                      {{ changeMonthNumberToName(period.month) }}-{{
                        period.year
                      }}
                    </td>
                    <td>{{ period.chargeble }}</td>
                    <td>{{ period.nonChargeble }}</td>
                    <td>{{ period.chargeble + period.nonChargeble }}</td>
                  </tr>
                  <tr *ngIf="periodIndex != 0">
                    <td
                      (click)="
                        getDaywiseConveyanceDetails(
                          details.firstName,
                          details.lastName,
                          details.usersId,
                          period.month,
                          period.year
                        )
                      "
                      style="cursor: pointer; color: #800000!important"
                    >
                      {{ changeMonthNumberToName(period.month) }}-{{
                        period.year
                      }}
                    </td>
                    <td>{{ period.chargeble }}</td>
                    <td>{{ period.nonChargeble }}</td>
                    <td>{{ period.chargeble + period.nonChargeble }}</td>
                  </tr>
                  <tr
                    *ngIf="periodCount == periodIndex + 1"
                    style="background-color: #e1f4f7"
                  >
                    <td>Total</td>
                    <td>{{ getChargableTotal(details.periodDetails) }}</td>
                    <td>{{ getNonChargableTotal(details.periodDetails) }}</td>
                    <td>
                      {{ getChargableNonChargableTotal(details.periodDetails) }}
                    </td>
                  </tr>

                  <tr
                    *ngIf="
                      detailsCount == detailIndex + 1 &&
                      periodCount == periodIndex + 1 &&
                      branchCount == branchIndex + 1
                    "
                    style="background-color: #e1f4f7"
                  >
                    <td>Total</td>
                    <td></td>
                    <td></td>
                    <td>{{ getAllChargableTotal(role.branches) }}</td>
                    <td>{{ getAllNonChargableTotal(role.branches) }}</td>
                    <td>
                      {{ getAllChargableNonChargableTotal(role.branches) }}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>


<!--DayWise Conveyance Details-->
<div
  class="container" id="mainContent"
  *ngIf="daywiseConveyanceList != null && showDaywiseConveyanceDetails"
>
<div class="row justify-content-center text-center pt-3">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>

  <div class="row pt-3">
    <div class="col-sm-5" (click)="goBack()">
      <i class="fa fa-arrow-circle-o-left fa-2x"></i>
    </div>
    <div class="col-sm-5">
      <span class="bg-theme-title">Daywise Conveyance Details</span>
    </div>
    <div class="col-md-2">
      <button
        (click)="exportToExcelDaywiseConveyance()"
        class="btn btn-sm btn-block btn-outline-theme"
      >
        <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
      </button>
    </div>
  </div>
  <div class="mt-3">
    <div class="row">
      <div class="col-sm-6">
        <label class="col-form-label">
          <b>Employee Name: {{ employeeName }}</b>
        </label>
      </div>
      <div class="col-sm-6" style="display: flex; justify-content: flex-end">
        <label class="col-form-label">
          <b
            >Closing Date:
            {{
              selectedClosing.closingDate === "Not Closed"
                ? "Not Closed"
                : (selectedClosing.closingDate | date: "dd-MMM-yyyy")
            }}</b
          >
        </label>
      </div>
    </div>

    <div class="row col-md-12">
      <table class="table table-bordered table-sm table-striped">
        <thead>
          <tr>
            <th>Diary Date</th>
            <th>Day</th>
            <th>Client Name</th>
            <th>Travelling From</th>
            <th>Mode</th>
            <th>Distance in Kms</th>
            <th>Rate</th>
            <th>Conveyance</th>
            <th>Approver Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let detail of daywiseConveyanceList">
            <td>{{ detail.entryDate | date: "dd-MMM-yyyy" }}</td>
            <td>{{ detail.day }}</td>
            <td>{{ detail.client }}</td>
            <td>{{ detail.travellingFrom }}</td>
            <td>{{ detail.mode }}</td>
            <td>{{ detail.distanceFromOffice }}</td>
            <td>{{ detail.rate }}</td>
            <td>{{ detail.conveyance }}</td>
            <td>
              {{ detail.approverFirstName }} {{ detail.approverLastName }}
            </td>
          </tr>
          <tr style="background-color: #e1f4f7">
            <td>Total</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ totalDistance }}</td>
            <td>{{ totalRate }}</td>
            <td>{{ totalConveyance }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>